export default {
  en: {
    'evaluating': 'evaluating',
    'end_season': 'end season',
    'x_minute': '{minute}.',
    'end_of_season': 'end of season',
    'end_of_season_info': 'end of season info',
    'new_season': 'new season',
    'home_short': 'H',
    'away_short': 'A',
    '': '',
  }
};